import { render, staticRenderFns } from "./SportsBookPayouts.vue?vue&type=template&id=cb99f7ea&scoped=true&"
import script from "./SportsBookPayouts.vue?vue&type=script&lang=js&"
export * from "./SportsBookPayouts.vue?vue&type=script&lang=js&"
import style0 from "./SportsBookPayouts.vue?vue&type=style&index=0&id=cb99f7ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb99f7ea",
  null
  
)

export default component.exports